import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

export type Guard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => void;

export default function middleware(guards: Guard | Guard[]): Guard {
  const guardsArray = Array.isArray(guards) ? guards : [guards];

  return (to, from, next) => middlewareSequence(guardsArray, to, from, next);
}

function middlewareSequence(
  guards: Guard[],
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void {
  const guardsLeft = [...guards];
  const nextGuard = guardsLeft.shift();

  if (nextGuard === undefined) {
    next();
    return;
  }

  nextGuard(to, from, (nextArg) => {
    if (nextArg === undefined) {
      middlewareSequence(guardsLeft, to, from, next);
      return;
    }
    next(nextArg as Parameters<NavigationGuardNext>[0]);
  });
}
